<template>
  <div class="filter-popover-container">
    <!-- Filter button -->
    <button ref="filterBtn" class="filter-popover-action-btn filter-popover-action-btn-icon" @click="toggleFilterMenu"
      v-b-tooltip.bottom title="Filtros">
      <i class="bx bx-filter"></i>
    </button>

    <!-- Filter Popover -->
    <div v-if="isFilterMenuOpen" class="filter-popover">
      <div class="filter-popover-header">
        <h6 class="filter-popover-title">{{ getTranslations('expression_1124') }}</h6>
        <button class="filter-popover-close-btn" @click="toggleFilterMenu">
          <i class="bx bx-x"></i>
        </button>
      </div>

      <!-- Search field inside the filter -->
      <div class="filter-popover-search">
        <i class="bx bx-search filter-popover-search-icon"></i>
        <input type="text" v-model="searchTerm" :placeholder="getTranslations('expression_128')"
          class="filter-popover-search-input" @input="handleSearch" />
        <i v-if="searchTerm" @click="clearSearch" class="bx bx-x filter-popover-clear-search"></i>
      </div>

      <div class="filter-popover-body">
        <!-- Two-panel layout -->
        <div class="filter-popover-panels">
          <!-- Left panel - Categories -->
          <div class="filter-popover-panel filter-popover-categories">
            <div class="filter-popover-category-item" :class="{ 'active': activeCategory === 'general' }"
              @click="setActiveCategory('general')">
              <span>{{getTranslations('expression_1422')}}</span>
            </div>
            <div class="filter-popover-category-item" :class="{ 'active': activeCategory === 'custom' }"
              @click="setActiveCategory('custom')">
              <span>{{getTranslations('expression_1410')}}</span>
            </div>
          </div>

          <!-- Right panel - Filter options -->
          <div class="filter-popover-panel filter-popover-options">
            <!-- Filtros Gerais -->
            <div v-if="activeCategory === 'general'" class="filter-popover-options-content">
              <!-- Canal filter -->
              <div class="filter-popover-option">
                <div class="filter-popover-icon">
                  <i class="bx bx-broadcast"></i>
                </div>
                <div class="filter-popover-content">
                  <div class="filter-popover-option-title">{{getTranslations('expression_4')}}</div>
                  <select v-model="leads.search_lead.channel_id"  class="filter-popover-select">
                    <option :value="null">{{ getTranslations('expression_123') }}</option>
                    <option v-for="channel in channels.data" :key="channel.id" :value="channel.id">
                      {{ channel.name }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Newsletter filter -->
              <div class="filter-popover-option">
                <div class="filter-popover-icon">
                  <i class="bx bx-envelope"></i>
                </div>
                <div class="filter-popover-content">
                  <div class="filter-popover-option-title">Newsletter</div>
                  <select v-model="leads.search_lead.newsletter_key" 
                    class="filter-popover-select">
                    <option :value="null">{{ getTranslations('expression_903') }}</option>
                    <option v-for="newsletter in configs.data.lead_campaigns" :key="newsletter.id"
                      :value="newsletter.id">
                      {{ newsletter.name }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Status filter -->
              <div class="filter-popover-option">
                <div class="filter-popover-icon">
                  <i class="bx bx-check-circle"></i>
                </div>
                <div class="filter-popover-content">
                  <div class="filter-popover-option-title">Status</div>
                  <select v-model="leads.search_lead.status_key"  class="filter-popover-select">
                    <option :value="null">{{ getTranslations('expression_903') }}</option>
                    <option v-for="status in configs.data.lead_statuses" :key="status.id" :value="status.id">
                      {{ status.name }}</option>
                  </select>
                </div>
              </div>

              <!-- Período filter -->
              <div class="filter-popover-option">
                <div class="filter-popover-icon">
                  <i class="bx bx-calendar-alt"></i>
                </div>
                <div class="filter-popover-content">
                  <div class="filter-popover-option-title">{{getTranslations('expression_708')}}</div>
                  <div class="filter-popover-date-range-inputs">
                    <input type="date" v-model="leads.search_lead.start_date" 
                      class="filter-popover-input filter-popover-date-input" :placeholder="getTranslations('expression_814')" />
                    <input type="date" v-model="leads.search_lead.final_date" 
                      class="filter-popover-input filter-popover-date-input" :placeholder="getTranslations('expression_815')" />
                  </div>
                </div>
              </div>

              <!-- Tag filter -->
              <div class="filter-popover-option">
                <div class="filter-popover-icon">
                  <i class="bx bx-tag"></i>
                </div>
                <div class="filter-popover-content">
                  <div class="filter-popover-option-title">Tags</div>
                  <div v-if="leads.search_lead.channel_id !== null">
                    <div class="filter-popover-tags-selection">
                      <div v-for="tag in filteredTags" :key="tag.id" class="filter-popover-tag-checkbox">
                        <input type="checkbox" :id="`tag-${tag.id}`" :value="tag.id" v-model="leads.search_lead.tags_id"
                          >
                        <label :for="`tag-${tag.id}`">{{ tag.name }}</label>
                      </div>
                    </div>
                  </div>
                  <div v-else class="filter-popover-empty-state">
                    {{getTranslations('expression_1415')}}
                  </div>
                </div>
              </div>
            </div>

            <!-- Campos Personalizados -->
            <div v-if="activeCategory === 'custom'" class="filter-popover-options-content">
              <!-- Selecionar Canal -->
              <div class="filter-popover-option">
                <div class="filter-popover-icon">
                  <i class="bx bx-broadcast"></i>
                </div>
                <div class="filter-popover-content">
                  <div class="filter-popover-option-title">{{getTranslations('expression_4')}}</div>
                  <select v-model="customFieldValues.channel" @change="onChannelSelect" class="filter-popover-select">
                    <option :value="null">{{ getTranslations('expression_123') }}</option>
                    <option v-for="channel in channels.data" :key="channel.id" :value="channel.id">
                      {{ channel.name }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Campos personalizados selecionados -->
              <div v-if="customFieldValues.channel && customFields.length > 0" class="filter-popover-option">
                <div class="filter-popover-icon">
                  <i class="bx bx-list-check"></i>
                </div>
                <div class="filter-popover-content">
                  <div class="filter-popover-option-title">{{getTranslations('expression_1420')}}</div>
                  <div class="filter-popover-selected-fields">
                    <div v-for="(field, index) in selectedFields" :key="index" class="filter-popover-selected-field">
                      <span>{{ getFieldName(field.field_id) }}</span>
                      <button @click="removeField(index)" class="filter-popover-remove-field">
                        <i class="bx bx-x"></i>
                      </button>
                    </div>
                    <div v-if="selectedFields.length === 0" class="filter-popover-empty-state">
                      {{getTranslations('expression_1421')}}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Selecionar Campo Personalizado -->
              <div v-if="customFieldValues.channel && customFields.length > 0" class="filter-popover-option">
                <div class="filter-popover-icon">
                  <i class="bx bx-detail"></i>
                </div>
                <div class="filter-popover-content">
                  <div class="filter-popover-option-title">{{getTranslations('expression_1418')}}</div>
                  <div class="filter-popover-field-selector">
                    <select v-model="newFieldId" class="filter-popover-select">
                      <option :value="null">{{getTranslations('expression_1419')}}</option>
                      <option v-for="field in availableFields" :key="field.id" :value="field.id">
                        {{ field.field_name }}
                      </option>
                    </select>
                    <button 
                      @click="addField" 
                      class="filter-popover-add-field-btn"
                      :disabled="!newFieldId"
                    >
                      <i class="bx bx-plus"></i> {{getTranslations('expression_693')}}
                    </button>
                  </div>
                </div>
              </div>

              <!-- Mensagem quando não há campos disponíveis -->
              <div v-if="customFieldValues.channel && customFields.length === 0" class="filter-popover-option">
                <div class="filter-popover-icon">
                  <i class="bx bx-info-circle"></i>
                </div>
                <div class="filter-popover-content">
                  <div class="filter-popover-empty-state">
                    {{getTranslations('expression_1417')}}
                  </div>
                </div>
              </div>

              <!-- Mensagem quando não há canal selecionado -->
              <div v-if="!customFieldValues.channel" class="filter-popover-option">
                <div class="filter-popover-icon">
                  <i class="bx bx-info-circle"></i>
                </div>
                <div class="filter-popover-content">
                  <div class="filter-popover-empty-state">
                    {{getTranslations('expression_1416')}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-popover-footer">
        <button class="filter-popover-btn-clear" @click="clearFilters">
          {{ getTranslations('expression_810') }}
        </button>

        <!-- Botão para Filtros Gerais -->
        <button v-if="activeCategory === 'general'" class="filter-popover-btn-apply" @click="applyGeneralFilters">
          {{ getTranslations('expression_60') }}
        </button>

        <!-- Botão para Campos Personalizados -->
        <button v-if="activeCategory === 'custom'" class="filter-popover-btn-apply" @click="applyCustomFieldFilters"
          :disabled="customFieldValues.channel === null || selectedFields.length === 0">
          {{ getTranslations('expression_60') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import "../../assets/css/FilterPopover.css";
export default {
  name: "FilterPopover",
  data() {
    return {
      isFilterMenuOpen: false,
      searchTerm: "",
      searchDebounceTimeout: null,
      isLoadingLeads: false,
      activeCategory: "general",
      customFieldValues: {
        channel: null,
        fields: []
      },
      selectedFields: [],
      newFieldId: null,
      customFields: [],
      isFiltering: false
    };
  },
  computed: {
    ...mapState(['leads', 'customfields', 'channels', 'tags', 'configs']),
    ...mapGetters([
      'getTagObject',
      'getCustomFields',
      'getCustomField',
    ]),
    filteredTags() {
      const channelId = this.leads.search_lead.channel_id;
      if (!channelId) return [];
      return this.tags.data.filter(tag => tag.channel_id === channelId);
    },
    // filteredChannels() {
    //   return this.channels.data.filter(channel =>
    //     channel.parameter &&
    //     channel.parameter.modules &&
    //     channel.parameter.modules.active === 1 &&
    //     channel.status_key === 1
    //   );
    // },
    availableFields() {
      // Retorna apenas os campos que ainda não foram selecionados
      return this.customFields.filter(field => 
        !this.selectedFields.some(selected => selected.field_id === field.id)
      );
    }
  },
  methods: {
    toggleFilterMenu() {
      this.isFilterMenuOpen = !this.isFilterMenuOpen;
    },
    
    async onChannelSelect() {
      const channelId = this.customFieldValues.channel;

      if (!channelId) {
        this.customFields = [];
        this.selectedFields = [];
        return;
      }

      this.selectedFields = [];
      this.newFieldId = null;

      try {
        const fields = await this.$store.dispatch("fetchCustomFields", channelId);
        this.customFields = fields.filter(f => !f.hidden);
      } catch (error) {
        console.error("Erro ao buscar campos personalizados:", error);
        this.customFields = [];
      }
    },
    
    getFieldName(fieldId) {
      const field = this.customFields.find(f => f.id === fieldId);
      return field ? field.field_name : 'Campo desconhecido';
    },
    
    addField() {
      if (!this.newFieldId) return;
      
      this.selectedFields.push({
        field_id: this.newFieldId
      });
      
      this.newFieldId = null;
    },
    
    removeField(index) {
      this.selectedFields.splice(index, 1);
    },

    setActiveCategory(category) {
      this.activeCategory = category;

      if (category === 'custom') {
        // Limpa os filtros gerais
        this.leads.search_lead = {
          name: "",
          phone: "",
          email: "",
          office: "",
          company: "",
          status_key: null,
          channel_id: null,
          start_date: null,
          final_date: null,
          newsletter_key: null,
          tags_id: []
        };
      }

      if (category === 'general') {
        // Limpa os filtros de campos personalizados
        this.customFieldValues = {
          channel: null,
          fields: []
        };
        this.selectedFields = [];
        this.customFields = [];
      }
    },

    handleSearch() {
  this.$store.dispatch("setLeadsLoading", true);

  clearTimeout(this.searchDebounceTimeout);
  this.searchDebounceTimeout = setTimeout(() => {
    this.searchLeads().finally(() => {
      this.$store.dispatch("setLeadsLoading", false);
    });
  }, 500);
},

    clearSearch() {
      this.searchTerm = "";
      this.handleSearch();
    },

    clearFilters() {
      if (this.activeCategory === 'general') {
        this.leads.search_lead = {
          name: "",
          phone: "",
          email: "",
          office: "",
          company: "",
          status_key: null,
          channel_id: null,
          start_date: null,
          final_date: null,
          newsletter_key: null,
          tags_id: []
        };
        this.leads.filter_leads_active = false;
      } else {
        this.customFieldValues.channel = null;
        this.selectedFields = [];
        this.customFields = [];
      }
      
      this.leads.filter_leads_active = false;
    },

    async searchLeads() {
      this.leads.search_lead.page = 1;
  //pega o termo já limpo
  const term = this.searchTerm.trim();

  // depois zera os campos
  this.leads.search_lead.name = "";
  this.leads.search_lead.email = "";
  this.leads.search_lead.phone = "";

  // lógica de detecção
  if (term.includes("@")) {
    this.leads.search_lead.email = term;
  } else if (/^\d+$/.test(term)) {
    this.leads.search_lead.phone = term;
  } else {
    this.leads.search_lead.name = term;
  }


// console.log("🔍 Filtro aplicado:", {
//   nome: this.leads.search_lead.name,
//   email: this.leads.search_lead.email,
//   telefone: this.leads.search_lead.phone
// });
this.isLoadingLeads = true;
      try {
        await this.$store.dispatch("getLeads", this.leads.search_lead);
        await this.$store.dispatch("getLeadsInfo", this.leads.search_lead);

        this.leads.filter_leads_active = true;

        if (!this.leads.pagination || !this.leads.pagination.data.length) {
          console.warn("Nenhum lead encontrado com os filtros atuais.");
        }
      } catch (error) {
        console.error("Erro ao buscar leads:", error);
      }
      finally {
      this.isLoadingLeads = false;
    }
    },

    async applyGeneralFilters() {
  this.$store.dispatch("setLeadsLoading", true);
  this.isFilterMenuOpen = false;
  this.leads.search_lead.page = 1;

  
  this.$nextTick(() => {
    setTimeout(async () => {
      try {
        await this.$store.dispatch("getFilterLeads", this.leads.search_lead);
        await this.$store.dispatch("getLeadsInfo", this.leads.search_lead);
        this.leads.filter_leads_active = true;
      } catch (error) {
        console.error("Erro ao aplicar filtros gerais:", error);
      }
     
    }); 
  });
},

// async applyCustomFieldFilters() {
//   if (!this.customFieldValues.channel || this.selectedFields.length === 0) {
//     console.warn('Canal não selecionado ou nenhum campo selecionado.');
//     return;
//   }

//   this.isFilterMenuOpen = false;
//   this.$store.dispatch('setLeadsLoading', true);

//   const channel = this.customFieldValues.channel;
//   // monta o array no formato que o backend espera:
//   // cada item precisa de custom_field_id e custom_field_value
//   const customFieldsPayload = this.selectedFields.map(f => ({
//     custom_field_id: f.field_id,
//     custom_field_value: ''   // aqui você pode usar um texto específico, se quiser buscar por valor.
//   }));

//   const payload = {
//     page: 1,
//     channel_id: channel,
//     custom_fields: customFieldsPayload
//   };

//   try {
//     // dispara a busca e deixa o backend filtrar
//     const response = await this.$store.dispatch('getFilterLeads', payload);

//     // ativa a flag de filtro
//     this.leads.filter_leads_active = true;

//     // atualiza os cards de info (total, válidos, inválidos…)
//     await this.$store.dispatch('getLeadsInfo', { channel_id: channel });

//     // se quiser dar um aviso ao usuário
//     if (response.data.data.length === 0) {
//       console.warn(
//         'Nenhum lead encontrado com os filtros de campos personalizados selecionados.'
//       );
//     }
//   } catch (error) {
//     console.error('Erro ao filtrar por campos personalizados:', error);
//   } finally {
//     this.$store.dispatch('setLeadsLoading', false);
//   }
// }
async applyCustomFieldFilters() {
  if (!this.customFieldValues.channel || this.selectedFields.length === 0) {
    console.warn('Canal não selecionado ou nenhum campo selecionado.');
    return;
  }

  this.isFilterMenuOpen = false;
  this.$store.dispatch("setLeadsLoading", true);

  const channel = this.customFieldValues.channel;
  const fieldIds = this.selectedFields.map(field => field.field_id);

  const payload = {
    page: 1,
    channel_id: channel,
    custom_field_ids: fieldIds 
  };

  this.$nextTick(() => {
    setTimeout(async () => {
  try {
    await this.$store.dispatch("getFilterLeads", payload);
    await this.$store.dispatch('getLeadsInfo', payload);
    this.leads.filter_leads_active = true;
  } catch (error) {
    console.error("Erro ao filtrar por campos personalizados:", error);
  } finally {
    this.$store.dispatch("setLeadsLoading", false);
  }
}); 
});
}
  }
}
</script>

